import { branchForDma } from "../data/branches";
import type { DataRow } from "../types";

type JobProperties = Record<string, string | number | boolean | null>;

export function jobsGeoJson(rows: DataRow[]): GeoJSON.FeatureCollection<GeoJSON.Point, JobProperties> {
  return {
    type: "FeatureCollection",
    features: rows.filter((row) => row.latitude !== null && row.longitude !== null).map((row) => {
      const branch = branchForDma(row.dmaCode);
      return {
        type: "Feature",
        id: row.__rowId,
        properties: {
          rowId: row.__rowId,
          jobId: row.jobId,
          status: row.status,
          dmaCode: row.dmaCode,
          originalDmaCode: row.originalDmaCode !== undefined ? row.originalDmaCode : row.dmaCode,
          dmaReviewStatus: row.dmaReviewStatus ?? null,
          dmaSuggestedCode: row.dmaSuggestedCode ?? null,
          dmaConfidence: row.dmaConfidence ?? null,
          dmaMethod: row.dmaMethod ?? null,
          branchNumber: branch?.number ?? null,
          branchShortName: branch?.shortName ?? null,
          branchFullName: branch?.fullName ?? null,
          reportedDetail: row.reportedDetail ?? null,
          workDetail: row.workDetail ?? null,
        },
        geometry: { type: "Point", coordinates: [row.longitude!, row.latitude!] },
      };
    }),
  };
}
